import type { RequestHireMegamovil, ResponsePackageItem, ServicioMegaMovil } from "../../../types/common";

type LineType = "SIM" | "ESIM";

interface BuildHireMegaMovilPayloadParams {
    item: ResponsePackageItem;
    cantidad: string;
    curp: string;
    rfc: string;
    tipificacion: string;
    lineTypeSelections: LineType[];
    familyLineDefinitions: ServicioMegaMovil[];
}

const getLineQuantity = (lineType: LineType): 0 | 1 => (lineType === "ESIM" ? 1 : 0);

const getIndividualServiceId = (item: ResponsePackageItem): string | null => {
    const servicios = item.servicios ?? [];

    const principalLine = servicios.find(
        (line) => (line.tipo_linea ?? "").toUpperCase() === "P" && Boolean(line.servicio?.trim())
    );
    if (principalLine?.servicio) {
        return principalLine.servicio.trim();
    }

    const firstValidLine = servicios.find((line) => Boolean(line.servicio?.trim()));
    return firstValidLine?.servicio?.trim() ?? null;
};

export const buildHireMegaMovilPayload = ({
    item,
    cantidad,
    curp,
    rfc,
    tipificacion,
    lineTypeSelections,
    familyLineDefinitions,
}: BuildHireMegaMovilPayloadParams): RequestHireMegamovil => {
    const basePayload = {
        id_paquete: item.idPackage,
        curp,
        rfc,
        cantidad,
        tipificacion,
    };

    if (item.packageType === "FAMILIAR") {
        const eSim = familyLineDefinitions.map((lineDefinition, index) => ({
            servicio: lineDefinition.servicio,
            cantidad: getLineQuantity(lineTypeSelections[index] ?? "SIM"),
        }));

        return {
            ...basePayload,
            cantidad: "1",
            servicio: "",
            eSim,
        };
    }

    if (item.packageType === "INDIVIDUAL") {
        const eSimCount = lineTypeSelections.filter((lineType) => lineType === "ESIM").length;
        const individualServiceId = getIndividualServiceId(item);

        if (!individualServiceId) {
            throw new Error("No se encontró un servicio válido para contratación individual.");
        }

        return {
            ...basePayload,
            servicio: individualServiceId,
            eSim: [eSimCount],
        };
    }

    return basePayload;
};
